<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="receiptTransfers.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="180"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="receiptTransfer"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :receiptTransfer="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="receiptTransfers.per_page"
        layout="total, prev, pager, next"
        :total="receiptTransfers.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'created_at',
          order: 'descending',
        },
      };
    },
    computed: {
      receiptTransfers() {
        return this.$store.getters['receiptTransfer/receiptTransfers'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['receiptTransfer/tableConfig']));
      },
      loading() {
        return this.$store.getters['receiptTransfer/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('receiptTransfer/setFilterString', '');
      this.$store.commit('receiptTransfer/setCurrentPage', this.currentPage);
      this.$store.commit('receiptTransfer/setSorting', this.currentSort);
      await this.$store.dispatch('receiptTransfer/fetchAll');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('receiptTransfer/setCurrentPage', val);
        this.$store.dispatch('receiptTransfer/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('receiptTransfer/setSorting', { prop, order });
          this.$store.dispatch('receiptTransfer/fetchAll');
        }
      },
    },
  };
</script>

